(() => {
  const dialog = document.getElementById('mc-welcome-dialog');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const keys = { cooldown:'mc_welcome_cooldown_v1', subscribed:'mc_welcome_subscribed_v1', elapsed:'mc_welcome_elapsed_v1', seen:'mc_welcome_seen_v1', pending:'mc_welcome_pending_v1', expiry:'mc_welcome_expiry_v1' };
  const memory = {};
  let persistentStorage = true;
  try { localStorage.setItem('mc_welcome_storage_test','1'); localStorage.removeItem('mc_welcome_storage_test'); } catch { persistentStorage = false; }
  const read = (key) => { try { return localStorage.getItem(key) ?? memory[key]; } catch { return memory[key]; } };
  const write = (key,value) => { memory[key]=String(value); try { localStorage.setItem(key,String(value)); } catch {} };
  const sessionRead = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const sessionWrite = (key,value) => { try { sessionStorage.setItem(key,String(value)); } catch {} };
  const design = dialog.dataset.designMode === 'true';
  const known = dialog.dataset.knownCustomer === 'true';
  const success = document.querySelector('[data-mc-welcome-success]');
  const offer = dialog.querySelector('[data-mc-step="offer"]');
  const email = dialog.querySelector('[data-mc-step="email"]');
  const claim = dialog.querySelector('[data-mc-claim]');
  const eligible = () => design || (persistentStorage && !known && !read(keys.subscribed) && Number(read(keys.cooldown)||0) <= Date.now());
  const close = () => { if(dialog.open) dialog.close(); };
  dialog.querySelectorAll('[data-mc-close]').forEach(button => button.addEventListener('click',close));
  dialog.addEventListener('click',event=>{ if(event.target === dialog) { const box=dialog.getBoundingClientRect(); if(event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom) close(); } });
  claim.addEventListener('click',()=>{ offer.hidden=true; email.hidden=false; email.querySelector('input[type=email]')?.focus(); });
  dialog.querySelector('[data-mc-back]').addEventListener('click',()=>{email.hidden=true;offer.hidden=false;claim.focus();});
  document.querySelectorAll('.mc-newsletter-form').forEach(form=>form.addEventListener('submit',()=>{
    if(!form.checkValidity()) return;
    sessionWrite(keys.pending, form.closest('.mc-welcome-form--popup')?'popup':'footer');
  }));
  if(known || success) write(keys.subscribed,'1');
  if(success && sessionRead(keys.pending)==='popup') {
    offer.hidden=true;email.hidden=false;
    dialog.querySelector('[data-mc-back]').hidden=true;
    dialog.showModal();
    sessionWrite(keys.pending,'');
  } else if(dialog.querySelector('.mc-form-error') && sessionRead(keys.pending)==='popup') {
    offer.hidden=true;email.hidden=false;dialog.showModal();
  }
  let elapsed=Number(read(keys.elapsed)||0);
  const lastSeen=Number(read(keys.seen)||0);
  if(Date.now()-lastSeen>30*60*1000 || Number(read(keys.cooldown)||0)>0 && Number(read(keys.cooldown))<=Date.now()) elapsed=0;
  let lastTick=Date.now();
  const show = async () => {
    const open = () => { if(!eligible() || dialog.open) return; if(!design){write(keys.cooldown,Date.now()+24*60*60*1000);write(keys.elapsed,0);} dialog.showModal(); };
    if(navigator.locks?.request) await navigator.locks.request('mc-welcome-display',open); else open();
  };
  if(design && !dialog.open) show();
  const tick = setInterval(()=>{
    const now=Date.now();
    if(!document.hidden && eligible() && !dialog.open){
      elapsed+=Math.min(1000,Math.max(0,now-lastTick));
      write(keys.elapsed,elapsed);write(keys.seen,now);
      if(elapsed>=Number(dialog.dataset.delay)){clearInterval(tick);show();}
    } else if(!eligible()) clearInterval(tick);
    lastTick=now;
  },250);
  document.addEventListener('visibilitychange',()=>{lastTick=Date.now();});
  window.addEventListener('storage',event=>{ if(event.key===keys.subscribed && event.newValue) close(); if(event.key===keys.cooldown && !dialog.open) clearInterval(tick); });
  const counter=document.querySelector('[data-mc-countdown]');
  const offerUrl=new URL(location.href);
  const raw=offerUrl.searchParams.get('mc_offer_ends') || new URLSearchParams(offerUrl.hash.slice(1)).get('mc_offer_ends');
  if(raw && /^\d{10}$/.test(raw)){
    const expires=Number(raw)*1000;
    if(expires>Date.now() && expires<Date.now()+72*60*60*1000) write(keys.expiry,expires);
  }
  const expiry=Number(read(keys.expiry)||0);
  if(counter && expiry>Date.now()){
    counter.hidden=false;
    const time=counter.querySelector('[data-mc-time]');
    time.dateTime=new Date(expiry).toISOString();
    const update=()=>{
      const seconds=Math.max(0,Math.floor((expiry-Date.now())/1000));
      time.textContent=[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(x=>String(x).padStart(2,'0')).join(' : ');
      if(!seconds){counter.querySelector('[data-mc-expired]').hidden=false;time.hidden=true;clearInterval(counterTick);}
    };
    let counterTick=setInterval(update,1000);update();
    counter.querySelector('[data-mc-countdown-close]').addEventListener('click',()=>{counter.hidden=true;clearInterval(counterTick);});
  }
})();

